<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-text-field
          name="name"
          :value="value.name"
          :counter="65"
          :label="`${$t('SERVICES.NAME_IN_THE_APP')} *`"
          :error-messages="errors['name']"
          :readonly="readonly"
          @input="updateValue('name', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <div class="text--secondary text-caption mt-1">
          {{ $t('ITEM.DESCRIPTION') }}
        </div>
        <v-card outlined>
          <ckeditor
            ref="editor"
            name="description"
            :value="value.description || ''"
            :editor="editor"
            :config="editorConfig"
            :style="editorStyle"
            @input="updateValue('description', $event)"
            @ready="onReady"
          >
          </ckeditor>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-text-field
          name="price_description"
          :value="value.price_description"
          :label="$t('SERVICES.DESCRIPTION_PRICE')"
          :counter="100"
          :error-messages="errors['price_description']"
          :readonly="readonly"
          @input="updateValue('price_description', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DecoupledDoc from '@ckeditor/ckeditor5-build-decoupled-document';
import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/de';

export default {
  props: {
    locale: {
      type: String,
      default: 'en'
    },
    languageId: {
      type: Number,
      required: true
    },
    value: {
      type: Object,
      default: () => ({
        name: '',
        description: '',
        price_description: ''
      })
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      editor: DecoupledDoc,
      editorStyle: {
        minHeight: '300px'
      }
    };
  },

  computed: {
    editorConfig() {
      return {
        language: this.locale,
        isReadOnly: this.readonly,
        removePlugins: [
          'Image',
          'ImageCaption',
          'ImageStyle',
          'ImageToolbar',
          'ImageUpload',
          'Link',
          'MediaEmbed'
        ],
        toolbar: [
          'heading',
          '|',
          'fontfamily',
          'fontsize',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          '|',
          'numberedList',
          'bulletedList',
          '|',
          'indent',
          'outdent',
          '|',
          'blockquote',
          'insertTable',
          '|',
          'undo',
          'redo'
        ]
      };
    }
  },

  mounted() {
    this.$emit('input', { ...this.value, language_id: this.languageId });
  },

  methods: {
    onReady(editor) {
      editor.isReadOnly = this.readonly;
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },

    updateValue(key, value) {
      this.$emit('input', {
        ...this.value,
        language_id: this.languageId,
        [key]: value
      });
    }
  }
};
</script>
